import { Injectable } from '@angular/core';
import { AppLoggerService } from '../app-logger.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor(private appLoggerService: AppLoggerService) { }

  log(msg: string, value?){
    this.appLoggerService.logException(new Error(msg), value);
  }
}
